import { Action, Selector, State, StateContext } from "@ngxs/store";
import { UserInterfaceStateModel } from "./ui-model";
import { Injectable, NgZone, ViewContainerRef } from "@angular/core";
import { Encounters } from "../encounters/encounter-actions";
import { ActivatedRoute, Router } from "@angular/router";
import { ReferralService } from "../../services/referral.service";
import { forkJoin, map } from "rxjs";
import { EncounterService } from "../../services/encounter.service";
import { Diaries, Users } from "@harlowe/core"
import { UserInterface } from "./ui-actions";

@State<UserInterfaceStateModel>
(
    {
        name: "userInterface",
        defaults: 
        {
            sidebarVisible: false,
            claimTrayOpen: false,
            referralClosureReasons: [],
            encounterClosureReasons: [],
            encounterStatuses: []
        }
    }
)

  @Injectable()
  export class UserInterfaceState
  {
    constructor
    (
        private router: Router,
        private route: ActivatedRoute,
        private _referrals: ReferralService,
        private _encounters: EncounterService,
        private _ngZone: NgZone
    )
    {
    }



    @Selector()
    static sidebarVisibility(state: UserInterfaceStateModel) 
    {
      return state.sidebarVisible;
    }

    @Selector()
    static claimTrayOpen(state: UserInterfaceStateModel)
    {
        return state.claimTrayOpen;
    }


    @Selector()
    static referralClosureReasons(state: UserInterfaceStateModel)
    {
        return state.referralClosureReasons;
    }

    @Selector()
    static encounterClosureReasons(state: UserInterfaceStateModel)
    {
        return state.encounterClosureReasons;
    }


    @Selector()
    static encounterStatuses(state: UserInterfaceStateModel)
    {
        return state.encounterStatuses;
    }

    @Action([Users.UserLoggedIn])
    loggedIn(ctx:StateContext<UserInterfaceStateModel>, action: Users.UserLoggedIn)
    {
        forkJoin
        ([        
            this._referrals.getReferralClosureReasons(),
            this._encounters.getEncounterClosureReasons(),
            this._encounters.getEncounterStatuses()
        ])
        .pipe
        (
            map
            (
                r =>
                {
                    ctx.patchState
                    (
                        {
                            referralClosureReasons: r[0],
                            encounterClosureReasons: r[1],
                            encounterStatuses: r[2]
                        }
                    )
                }
            )
        ).subscribe();
    }

    @Action([UserInterface.LoadRouteInSidebar])
    loadRouteInSidebar(ctx: StateContext<UserInterfaceStateModel>, action: UserInterface.LoadRouteInSidebar)
    {
        this._ngZone.run(()=> {
            this.router.navigate([{ outlets: { sidebar: [action.payload.route] } }],{relativeTo:this.route})
        });
        this.showSidebar(ctx);
    }

    @Action([UserInterface.CloseSidebar])
    closeSidebar(ctx: StateContext<UserInterfaceStateModel>)
    {
        this._ngZone.run(() => {
            this.router.navigate([''], { replaceUrl: true });
        });
        this.hideSidebar(ctx);
    }

    @Action([UserInterface.OpenSidebar])
    openSidebar(ctx: StateContext<UserInterfaceStateModel>)
    {
        this.showSidebar(ctx);
        ctx.dispatch(new Diaries.RefreshOpenDiaries)
        ctx.dispatch(new Diaries.RefreshClosedDiaries)
    }

    @Action([Encounters.EncounterOpenedFromEncounterManager])
    encounterOpened(ctx:StateContext<UserInterfaceStateModel>)
    {
        this._ngZone.run(() => {
            this.router.navigate([''], { replaceUrl: true });
        });
        this.hideSidebar(ctx);
    }

    @Action([UserInterface.OpenClaimTray])
    claimTrayOpened(ctx:StateContext<UserInterfaceStateModel>)
    {   
        this.showClaimTray(ctx);
    }


    @Action([UserInterface.CloseClaimTray])
    claimTrayClosed(ctx:StateContext<UserInterfaceStateModel>)
    {   
        this.hideClaimTray(ctx);
    }

    @Action([UserInterface.ToggleClaimTray])
    toggleClaimTray(ctx:StateContext<UserInterfaceStateModel>)
    {
        const state = ctx.getState();
        var ctOpen = state.claimTrayOpen;
        if(ctOpen)
            this.hideClaimTray(ctx);
        else
            this.showClaimTray(ctx)

    }

    showClaimTray(ctx:StateContext<UserInterfaceStateModel>)
    {
        const state = ctx.getState();
        ctx.setState({...state, claimTrayOpen: true});
    }

    hideClaimTray(ctx:StateContext<UserInterfaceStateModel>)
    {
        const state = ctx.getState();
        ctx.setState({...state, claimTrayOpen: false});
    }


    showSidebar(ctx:StateContext<UserInterfaceStateModel>)
    {
        const state = ctx.getState();

        ctx.setState
        (
            {
                ...state,
                sidebarVisible: true
            }
        )
    }

    hideSidebar(ctx:StateContext<UserInterfaceStateModel>)
    {
        const state = ctx.getState();

        ctx.setState
        (
            {
                ...state,
                sidebarVisible: false
            }
        )
    }
  }